import React from "react";
import ReactDOM from "react-dom";
//import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import auth from "auth/auth";
import { ApolloClient, InMemoryCache, ApolloProvider, ApolloLink, HttpLink, concat } from "@apollo/client";

import * as serviceWorker from "./serviceWorker";

const httpLink = new HttpLink({ uri: process.env.REACT_APP_GRAPHQL_URI });

const authLink = new ApolloLink((operation, forward) => {
  const token = auth.getIdToken();
  operation.setContext(({ headers }) => ({ headers: {
    authorization: token ? `Bearer ${token}` : "",
    ...headers
  }}));
  return forward(operation);
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: concat(authLink, httpLink)
});

const Main = () => (
  <BrowserRouter>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </BrowserRouter>
);

ReactDOM.render(<Main />, document.getElementById("root"));
serviceWorker.unregister();